module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_25-a7e06c2de2f5c9517fff1cfe1d979ffc.jpg";